import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { MaterialVisitorWidget } from '../../../business/visitor/material-visitor-widget';

@Component({
    selector: 'ecm-mat-visitor-home-widgets',
    templateUrl: 'material-visitor-home-widgets.html',
    standalone: true,
    imports: [NgClass],
})
export class MaterialVisitorHomeWidgetsComponent implements OnInit {
    @Input() public widgets: MaterialVisitorWidget;

    @Input() public e2e?: string;

    @Output() public visitorButtonClick: EventEmitter<{ zone: string; index: number; href?: string }> =
        new EventEmitter<{
            zone: string;
            index: number;
            href?: string;
        }>();

    /**
     * @inheritDoc
     */
    public ngOnInit(): void {
        // set e2e data tag
        this.e2e = this.e2e || 'e2e-material-visitor-home-accordion-modulo';
    }

    public emitButtonClickEvent(buttonZone: string, buttonIndex: number, href?: string): void {
        this.visitorButtonClick.emit({ zone: buttonZone, index: buttonIndex, href });
    }
}
